
export const validationMessages = {
  en: {
    custom: {
      btn_action: {
        //required: 'এটি অবশ্যই দিতে হবে',
        //in: 'অনুগ্রহ করে save বা submit এর মধ্যে একটি মান দিন'
      },
      // name_bng: {
      //   //required: 'অবশ্যই দিতে হবে',
      //   //max: 'নাম সর্বোচ্চ 90 অক্ষর হতে পারবে',
      //   //bangla: 'অনুগ্রহ করে শুধুমাত্র বাংলা অক্ষর ব্যবহার করুন',
      //   //no_number: 'নম্বর ব্যবহার করা যাবে না'
      // },
      // nid_brno: {
      //   //required: 'NID/BRN অবশ্যই দিতে হবে',
      //   //nid_brno: 'সঠিক NID(10 or 13 length)/BRN ( 17 length ) নম্বর দিন',
      //   //integer: 'NID/BRN অবশ্যই একটি সংখ্যা হতে হবে'
      // },
      // religion: {
      //   //required: 'ধর্ম অবশ্যই দিতে হবে',
      //   //max: 'ধর্ম সর্বোচ্চ 15 অক্ষর হতে পারবে'
      // },
      // spouse_name: {
      //   //required: 'স্বামীর/স্ত্রীর নাম অবশ্যই দিতে হবে',
      //   //max: 'নাম সর্বোচ্চ 90 অক্ষর হতে পারবে'
      // },
      // fmobile: {
      //   ///required: 'ফোন নম্বর অবশ্যই দিতে হবে',
      //   //mobile: 'ফোন নম্বর সঠিক নয়'
      // },
      // fname_bng: {
      //   //required: 'পিতার নাম অবশ্যই দিতে হবে',
      //   //max: 'নাম সর্বোচ্চ 90 অক্ষর হতে পারবে', 
      //   //bangla: 'অনুগ্রহ করে শুধুমাত্র বাংলা অক্ষর ব্যবহার করুন',
      //   //no_number: 'নম্বর ব্যবহার করা যাবে না'
      // },

      // fnid_brno: {
      //   //required: 'NID/BRN অবশ্যই দিতে হবে',
      //   //nid_brno: 'সঠিক NID(10 or 13 length)/BRN ( 17 length ) নম্বর দিন',
      //   //integer: 'NID/BRN অবশ্যই একটি সংখ্যা হতে হবে'
      // },
      // mname_bng: {
      //   //required: 'মাতার নাম অবশ্যই দিতে হবে',
      //   //max: 'নাম সর্বোচ্চ 90 অক্ষর হতে পারবে',
      //   //bangla: 'অনুগ্রহ করে শুধুমাত্র বাংলা অক্ষর ব্যবহার করুন',
      //   //no_number: 'নম্বর ব্যবহার করা যাবে না'
      // },
      // permanent_house: {
      //   //required_if: 'Permanent house অবশ্যই দিতে হবে যদি ঠিকানা একই না হয়',
      //   //max: 'Permanent house সর্বোচ্চ 150 অক্ষর হতে পারবে'
      // }
    }
  }
};
